import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSecurity, type Permission } from '../security/SecurityContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
  isAllowed?: boolean; // optional direct flag
  permission?: Permission; // permission to check via SecurityContext
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAllowed, permission, children, redirectPath = "/" }) => {
  const { has } = useSecurity();
  const allowed = typeof isAllowed === 'boolean' ? isAllowed : (permission ? has(permission) : true);
  if (!allowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
